import { render, staticRenderFns } from "./TravelItem.vue?vue&type=template&id=63cb4a8e&scoped=true&"
import script from "./TravelItem.vue?vue&type=script&lang=js&"
export * from "./TravelItem.vue?vue&type=script&lang=js&"
import style0 from "./TravelItem.vue?vue&type=style&index=0&id=63cb4a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb4a8e",
  null
  
)

export default component.exports